var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[(_vm.newDrpEnabled)?[_c('show-route-itinerary',{attrs:{"itinerary-id":_vm.$route.params.itineraryId,"route-id":_vm.$route.params.routeId}})]:[_c('old-route-itinerary',{attrs:{"itinerary-id":_vm.$route.params.itineraryId,"route-id":_vm.$route.params.routeId}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }